import _extends from "@babel/runtime/helpers/extends";
import React, { Suspense } from 'react';
import { useModals } from '../../context/ModalsContext';
import { Modal } from '@wix/design-system';
export const ModalWrapper = _ref => {
  let {
    children,
    withSuspense = false,
    ...props
  } = _ref;
  const ComputedModalComponent = /*#__PURE__*/React.createElement(ComputedModal, props, children);
  return withSuspense ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, ComputedModalComponent) : /*#__PURE__*/React.createElement(React.Fragment, null, ComputedModalComponent);
};
const ComputedModal = _ref2 => {
  let {
    children,
    isOpen = true,
    withModalComponent = true,
    ...props
  } = _ref2;
  const {
    hideModalOverlay
  } = useModals();
  if (hideModalOverlay || !withModalComponent) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  } else {
    return /*#__PURE__*/React.createElement(Modal, _extends({
      isOpen: isOpen
    }, props), children);
  }
};
//# sourceMappingURL=ModalWrapper.js.map